const config = {
  plugins: {
    "tailwindcss": {},
    "autoprefixer": {},
  },
};

export default config;
